<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <div class="text">
        <b>Välkommen till din digitala brevlåda för företag!</b>
      </div>
    </mat-card-title>

  </mat-card-header>
  <mat-card-content>
    <span class="text">
      <p>Här kan du som saknar vår mobil- och internetbank ta emot meddelanden från din rådgivare.</p>
    </span>

    <div class="button">
      <button
        (click)="start()"
        mat-flat-button>Logga in med BankID
      </button>
    </div>
    <div>

    </div>
    <div [style.display]="'none'">
      <spb-bankid (accessToken)="configService.setToken($event).subscribe()"
                  [bankIdUrl]="bankIdUrl"
                  [domain]="domain"
                  mode="login"
                  customButton="Logga in med BankID"
      ></spb-bankid>
    </div>
  </mat-card-content>
</mat-card>

